module.exports = __webpack_public_path__ + "static/media/TestCreation.114394de.svg";